import { WEDDING_STYLES } from "../../data/content";
import { Chapter, Reveal, Btn } from "../shared";

export default function WeddingStyles() {
  return (
    <section className="bg-sand py-24 md:py-32" data-testid="wedding-styles">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="02" title="Weddings We Create" />
        <div className="mt-6 flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] text-emerald">
              Your dream wedding,<br /><span className="italic text-gold-text">your way</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-stone2">Eight ways to celebrate — every format designed around your story, your guests and your destination.</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 md:auto-rows-[380px]">
          {WEDDING_STYLES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.12} className={s.span}>
              <article className="group relative h-full w-full overflow-hidden" data-testid={`wedding-style-card-${i}`}>
                <img src={s.img} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-deep/90 via-emerald-deep/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-gold-light">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-2 font-serif text-2xl md:text-3xl text-ivory">{s.title}</h3>
                  <p className="mt-2 max-w-md text-xs md:text-sm leading-relaxed text-ivory/70">{s.desc}</p>
                </div>
                <div className="absolute inset-3 border border-gold/0 transition-all duration-500 group-hover:border-gold/40" />
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14 text-center">
          <Btn to="/contact" testid="wedding-styles-cta">Start Planning My Wedding</Btn>
        </Reveal>
      </div>
    </section>
  );
}
